import React from 'react';
import { guideForRel } from '../data/sailingGuide';

/**
 * Sailing guide panel — shows the relevant point-of-sail advice
 * for every leg of the route, based on wind angle relative to the boat.
 */
export default function SailingGuide({ legs }) {
  if (!legs || legs.length === 0) return null;

  return (
    <div className="sg-container">
      <h4 className="sg-title">{'\u{1F4D6}'} Sailing Guide</h4>
      {legs.map((leg, i) => {
        const guide = guideForRel(leg.windRel);
        return (
          <div key={leg.id || i} className="sg-card">
            <div className="sg-card-head">
              <span className="sg-leg">WP {i + 1} {'\u2192'} WP {i + 2}</span>
              <span className="sg-chip">
                {leg.bearing} {leg.bearingDeg}{'\u00B0'}
              </span>
              <span className="sg-arrow">{'\u27A1'}</span>
              <span className="sg-chip sg-chip-wind">
                {leg.windRel ? `${leg.windRel} (${leg.windRelDeg > 0 ? '+' : ''}${leg.windRelDeg}\u00B0)` : 'no wind data'}
              </span>
              {leg.windRelDeg !== null
                ? <span className="sg-chip sg-chip-twa">TWA {Math.abs(leg.windRelDeg)}{'\u00B0'}</span>
                : null}
              {leg.maneuver && (
                <span className={`sg-chip sg-chip-maneuver ${leg.maneuver}`}>
                  {leg.maneuver === 'tack' ? '\u26A1 Tack here' : '\u21A9 Gybe here'}
                </span>
              )}
            </div>
            {guide ? (
              <div className="sg-body">
                <div className="sg-name">
                  <span className="sg-emoji">{guide.emoji}</span>
                  {guide.name}
                </div>
                <p className="sg-desc">{guide.desc}</p>
                <div className="sg-setup">
                  <span className="sg-setup-label">{'\u2697'} Sail setup:</span> {guide.setup}
                </div>
                <ul className="sg-checklist">
                  {guide.checklist.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              </div>
            ) : (
              <p className="sg-desc">Add wind data to this leg to see the sailing guide.</p>
            )}
          </div>
        );
      })}
    </div>
  );
}